import { Simulado } from '../@types';
import Service from './Service';

class SimuladoService extends Service {
  static getSimulados() {
    return this.Http.get<Simulado.Simulado[]>(
      '/mocktests'
    ).then(this.getData);
  }

  static getSimuladosDoUsuario() {
    return this.Http.get<Simulado.Simulado[]>(
      '/mocktests/allbyuser'
    ).then(this.getData);
  }

  static getSimulado(id: string) {
    return this.Http.get<Simulado.Simulado>(
      `/mocktests/${id}`
    ).then(this.getData);
  }

  static inserirNovoSimulado(simulado: Simulado.Simulado) {
    return this.Http.post<Simulado.Simulado>(
      '/mocktests',
      simulado
    ).then(this.getData);
  }

  static updateSimulado(simulado: Simulado.Simulado) {
    return this.Http.put<Simulado.Simulado>(
      '/mocktests',
      simulado
    ).then(this.getData);
  }

  static changeSituation(body: any) {
    return this.Http.put<Simulado.Simulado>(
      '/mocktests/changesituation',
      body
    ).then(this.getData);
  }
}

export default SimuladoService;
